import React from "react";
import "./cta.css";

const Cta = () => {
  return (
    <div className="cta">
      <di className="ctaContent">
        <p>Request Early Access to Get Started</p>
        <h3>Register today & start exploring the endless possiblities.</h3>
      </di>
      <div className="ctaButton">
        <button type="button">Get Started</button>
      </div>
    </div>
  );
};

export default Cta;
